import * as React from 'react';
import { StyledComponent } from 'styled-components';

/* Interfaces */
export interface PropsWithAs {
  as: As;
  [prop: string]: any;
}
export type As = keyof JSX.IntrinsicElements | React.ComponentType<any>;

/* Components */
// provides correct type of the generated component
// eslint-disable-next-line func-style,prefer-arrow/prefer-arrow-functions
export function StyledGeneric(styledComponent, as: As, props: {}) {
  return React.createElement(styledComponent as StyledComponent<typeof as, any, {}, never>, { ...props, as });
}
